module.exports = __webpack_public_path__ + "media/customizations/harbourisle/logo-new-a4fe01c2b150afc99b3835a4107d4c07.png";